(() => {
  if (window.petcaryMetaPixelLoaded) return;
  window.petcaryMetaPixelLoaded = true;
  const id = '2088671091729707';
  let initialized = false;
  let managed = false;
  function syncConsent() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    const allowed = privacy.marketingAllowed();
    if (!allowed) {
      if (managed && window.fbq) window.fbq('consent', 'revoke');
      return;
    }
    if (initialized) {
      if (managed) window.fbq('consent', 'grant');
      return;
    }
    const existing = window.fbq;
    const registered = existing && typeof existing.getState === 'function' && existing.getState().pixels;
    const queued = existing && existing.queue && existing.queue.some(call => call[0] === 'init' && String(call[1]) === id);
    if (queued || (registered && registered.some(pixel => String(pixel.id) === id))) {
      initialized = true;
      return;
    }
    if (!window.fbq) {
      const fbq = function() {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    managed = true;
    initialized = true;
    window.fbq('consent', 'grant');
    window.fbq('init', id);
    window.fbq('trackSingle', id, 'PageView');
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  function ready() {
    if (!window.Shopify) return;
    if (window.Shopify.customerPrivacy) syncConsent();
    else if (window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
        if (!error) syncConsent();
      });
    }
  }
  if (document.readyState === 'complete') ready();
  else window.addEventListener('load', ready, {once: true});
})();
